import React from 'react';
import { Paper, PaperProps } from '@mui/material';

const WidgetCard: React.FC<PaperProps> = ({ children, sx, ...rest }) => (
    <Paper
        elevation={0}
        sx={{
            p: { xs: 1.5, md: 2 },
            borderRadius: 2,
            boxShadow: 2,
            bgcolor: 'background.paper',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 4,
            },
            ...sx,
        }}
        {...rest}
    >
        {children}
    </Paper>
);

export default WidgetCard;
